export default __webpack_public_path__ + "static/media/iconUpdate.50773eb6.png";